<div id="getMessageLogs"
     class="table-header margin-top-30">
  <span style="margin-right:50px;">Logs</span>
  <span>
    <span class="table-icon refresh" (click)="refreshLogs()" style="float:none; margin-left:80px;">
      <i class="text-tooltip" [ngClass]="(messageLogsRefreshing)?'fa fa-spinner fa-spin':'fa fa-refresh'"
         aria-hidden="true"
         title-popup="Refresh">
      </i>
    </span>
    <span class="position-relative table-icon action" style="float:right; margin-top:0px;">
      <i class="fa fa-list transition text-tooltip"
         aria-hidden="true"
         title-popup="List">
      </i>
      <span class="tooltip-actions width-140">
        <span class="arrow-up"></span>
          <ul>
            <li>
              <label col-id="0"
                     table-name="logs-list"
                     class="checked">Time
              </label>
            </li>
            <li>
              <label col-id="1"
                     table-name="logs-list"
                     class="checked">Action
              </label>
            </li>
          <li>
            <label col-id="2"
                   table-name="logs-list"
                   class="checked">Reason
            </label>
          </li>
          <li>
            <label col-id="3"
                   table-name="logs-list"
                   class="checked">ResultCode
            </label>
          </li>
          <li>
            <label col-id="4"
                   table-name="logs-list"
                   class="checked">MsgType
            </label>
          </li>
          <li>
            <label col-id="5"
                   table-name="logs-list"
                   class="checked">TxID
            </label>
          </li>
          <li>
            <label col-id="6"
                   table-name="logs-list"
                   class="checked">SenderID
            </label>
          </li>
          <li>
            <label col-id="7"
                   table-name="logs-list"
                   class="checked">ReceiverID
            </label>
          </li>
          <li>
            <label col-id="8"
                   table-name="logs-list"
                   class="checked">Sender NSID
            </label>
          </li>
          <li>
            <label col-id="9"
                   table-name="logs-list"
                   class="checked">Receiver NSID
            </label>
          </li>
          <li>
            <label col-id="10"
                   table-name="logs-list"
                   class="checked">DevEUI
            </label>
          </li>
          <li>
            <label col-id="11"
                   table-name="logs-list"
                   class="checked">DevAddr
            </label>
          </li>
          <li>
            <label col-id="12"
                   table-name="logs-list"
                   class="checked">FCnt
            </label>
          </li>
          <li>
            <label col-id="13"
                   table-name="logs-list"
                   class="checked">Sender IP
            </label>
          </li>
          <li>
            <label col-id="14"
                   table-name="logs-list"
                   class="checked">Recevier IP
            </label>
          </li>
          <li *ngIf="isAdmin">
            <label col-id="15"
                   table-name="logs-list"
                   class="checked">Site ID
            </label>
          </li>
          <li *ngIf="isAdmin">
            <label col-id="16"
                   table-name="logs-list"
                   class="checked">Ingress PF
            </label>
          </li>
          <li *ngIf="isAdmin">
            <label col-id="17"
                   table-name="logs-list"
                   class="checked">Egress PF
            </label>
          </li>
        </ul>
      </span>
    </span>
  </span>

  <div class="table-filter" style="float:none;">
    <form class="form-inline">
      <span class="input-group date" style="width:auto; margin-right:20px;">
        <label style=" font-size:14px; color:#9B9B9B;">Start:</label>
        <input type="text" style="border:none;"
               class="form-control datepicker1 search-time"
               data-date-format="mm.dd.yyyy"
               (click)="showDatePicker1()">
        <label style=" font-size:14px; color:#9B9B9B;">End:</label>
        <input type="text" style="border:none;"
               class="form-control datepicker2 search-time"
               data-date-format="mm.dd.yyyy"
               (click)="showDatePicker2()">
      </span>
      <span class="input-group">
        <select [(ngModel)]="optionLogsSearch"
                class="table-filter-search form-control"
                name="optionLogsSearch"
                id="table-filter-search"
                class="table-filter-search form-control"
                (change)='onOptionLogsSearchChanged($event)'>
            <option value="Search Type" selected>Search Type</option>
            <option value="Message Type">Message Type</option>
            <option value="Sender ID">Sender ID</option>
            <option value="Receiver ID">Receiver ID</option>
            <option value="Transaction ID">Transaction ID</option>
            <option value="NetID">NetID/JoinEUI</option>
            <option value="NSID">NS ID</option>
            <option value="End-device identifier">DevEUI</option>
            <option value="Device address">DevAddr</option>
        </select>
        <input type="text"
               style="width:150px; border:none; z-index: 0;"
               class="form-control logs"
               id="input-logs-search"
               aria-describedby="search"
               placeholder="Search"
               name="inputLogsSearch"
               [(ngModel)]="inputKeywordLogsSearch"
               (keyup)="onKeywordSearch($event)">
      </span>
      <i class="fa fa-search logs text-tooltip" title-popup="Search"
         aria-hidden="true" (click)="updateLogsPagination(1)">
      </i>
    </form>
  </div>
</div>
<div class="table-panel">
  <table class="table table-striped table-responsive logs-list-netId"
         id="logs-list">
    <thead>
    <tr>
      <th>Time</th>
      <th class="text-tooltip"
          title-popup="Action">Action
      </th>
      <th class="text-tooltip"
          title-popup="RejectReason">Reason
      </th>
      <th class="text-tooltip"
          title-popup="ResultCode">ResultCode
      </th>
      <th class="text-tooltip"
          title-popup="Message Type">MsgType
      </th>
      <th class="text-tooltip"
          title-popup="Transaction ID">TxID
      </th>
      <th class="text-tooltip"
          title-popup="Sender ID">SenderID
      </th>
      <th class="text-tooltip"
          title-popup="Receiver ID">ReceiverID
      </th>
      <th class="text-tooltip"
          title-popup="Sender NSID">Sender NSID
      </th>
      <th class="text-tooltip"
          title-popup="Receiver NSID">Receiver NSID
      </th>
      <th class="text-tooltip"
          title-popup="End-device identifier">DevEUI
      </th>
      <th class="text-tooltip"
          title-popup="Device address">DevAddr
      </th>
      <th class="text-tooltip"
          title-popup="Frame Count">FCnt
      </th>
      <th class="text-tooltip"
          title-popup="Sender IP address">Sender IP
      </th>
      <th class="text-tooltip"
          title-popup="Receiver IP address">Receiver IP
      </th>
      <th *ngIf="isAdmin" class="text-tooltip"
          title-popup="Site ID">Site ID
      </th>
      <th *ngIf="isAdmin" class="text-tooltip"
          title-popup="Ingress PF ID">Ingress PF
      </th>
      <th *ngIf="isAdmin" class="text-tooltip"
          title-popup="Egress PF ID">Egress PF
      </th>
    </tr>
    </thead>
    <tbody>
    <tr
      *ngFor="let item of listLogs | paginate: { id:'pagerLogs', itemsPerPage: pageSize, currentPage: pLogs, totalItems: totalPageNumber}">
      <td class="logs-list-time">{{item.messageTime | date :'dd.MMM.yy HH:mm:ss'}}</td>
      <td *ngIf="item.policyResult==null || item.policyResult=='N/A'"></td>
      <td *ngIf="item.policyResult=='Hub-Reject' && item.rejectReason != 'N/A'">Drop</td>
      <td *ngIf="item.policyResult=='Hub-Reject' && item.rejectReason == 'N/A'">Generate</td>
      <td *ngIf="item.policyResult!='Hub-Reject'">{{item.policyResult}}</td>
      <td *ngIf="item.policyResult=='Hub-Reject' && item.rejectReason != 'N/A'">
        HubGenerated-Failed-{{item.rejectReason}}
      </td>
      <td *ngIf="item.policyResult=='Hub-Reject' && item.rejectReason == 'N/A'">HubGenerated</td>
      <td *ngIf="item.policyResult!='Hub-Reject'">{{item.rejectReason}}</td>
      <td>{{item.incomingMsgResult}}</td>
      <td>{{item.messageType}}</td>
      <td>{{item.transactionId}}</td>
      <td>{{item.senderId}}</td>
      <td>{{item.receiverId}}</td>
      <td>{{item.senderNsId}}</td>
      <td>{{item.receiverNsId}}</td>
      <td *ngIf="item.devEui==null || item.devEui=='N/A'"></td>
      <td *ngIf="item.devEui!=null && item.devEui!='N/A'">{{item.devEui}}</td>
      <td *ngIf="item.devAddr==null || item.devAddr=='N/A'"></td>
      <td *ngIf="item.devAddr!=null && item.devAddr!='N/A'">{{item.devAddr}}</td>
      <td *ngIf="item.fCnt==null || item.fCnt=='N/A'"></td>
      <td *ngIf="item.fCnt!=null && item.fCnt!='N/A'">{{item.fCnt}}</td>
      <td *ngIf="item.senderIP==null || item.senderIP=='N/A'"></td>
      <td *ngIf="item.senderIP!=null && item.senderIP!='N/A'">{{item.senderIP}}</td>
      <td *ngIf="item.receiverIP==null || item.receiverIP=='N/A'"></td>
      <td *ngIf="item.receiverIP!=null && item.receiverIP!='N/A'">{{item.receiverIP}}</td>
      <td *ngIf="isAdmin && (item.siteId==null || item.siteId=='N/A')"></td>
      <td *ngIf="isAdmin && (item.siteId!=null && item.siteId!='N/A')">{{item.siteId}}</td>
      <td *ngIf="isAdmin && (item.ingressPFid==null || item.ingressPFid=='N/A')"></td>
      <td *ngIf="isAdmin && (item.ingressPFid!=null && item.ingressPFid!='N/A')">{{item.ingressPFid}}</td>
      <td *ngIf="isAdmin && (item.egressPFid==null || item.egressPFid=='N/A')"></td>
      <td *ngIf="isAdmin && (item.egressPFid!=null && item.egressPFid!='N/A')">{{item.egressPFid}}</td>
    </tr>
    </tbody>
  </table>
  <div class="noDataRow"
       *ngIf="!listLogs || listLogs.length === 0">There is no data available
  </div>
</div>
<app-pagination-simulate #pagerLogsNetworkServer
                         [id]="'logs-list'"
                         [currentPage]="pLogs"
                         [itemsPerPage]="pageSize"
                         [totalItems]="totalPageNumber"
                         (pageChanged)="updateLogsPagination($event)">
</app-pagination-simulate>
